import { stockRoutePath } from '../constants/routes';

export const tokenRouteIdentifier = (token) => (
  token?.coingeckoSlug || token?.coingeckoApiId || ''
);

export const tokenRoutePath = (token) => {
  if (token?.assetType === 'STOCK') {
    return stockRoutePath(token.ticker || token.id);
  }
  const identifier = tokenRouteIdentifier(token);
  return identifier ? `/c/${encodeURIComponent(identifier)}` : '/positions';
};
